var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('span',[(
      _vm.file.toLowerCase().endsWith('.md') ||
      (_vm.language &&
        (_vm.language.toLowerCase() === 'md' ||
          _vm.language.toLowerCase() === 'markdown'))
    )?_c('Markdown',{attrs:{"content":_vm.content}}):_c('Code',{attrs:{"content":_vm.content,"language":_vm.language}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }